import dropdownCalendarFormSaga from './dropdownCalendarForm';

export default function* exampleFormSaga() {
  yield dropdownCalendarFormSaga();
}
